"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstInstalmentDueDate = getFirstInstalmentDueDate;
var moment = require("moment-timezone");
function getFirstInstalmentDueDate(interaction) {
    var _a, _b, _c, _d, _e, _f, _g;
    var paymentDay = (_c = (_b = (_a = interaction === null || interaction === void 0 ? void 0 : interaction.paymentDetails) === null || _a === void 0 ? void 0 : _a.directDebitDetails) === null || _b === void 0 ? void 0 : _b.paymentDay) !== null && _c !== void 0 ? _c : (_g = (_f = (_e = (_d = interaction === null || interaction === void 0 ? void 0 : interaction.paymentDetails) === null || _d === void 0 ? void 0 : _d.instalmentPlan) === null || _e === void 0 ? void 0 : _e.instalments) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.dueDate;
    var earliestInstalmentDueDate = moment(interaction.headerInfo.startDate).add(14, "days");
    var latestInstalmentDueDate = moment(interaction.headerInfo.startDate).add(44, "days");
    var initialFirstDueDate = moment(interaction.paymentDetails.instalmentPlan.instalments[0].dueDate).set("date", paymentDay);
    var firstDueDate;
    // In cases when earliest Instalment DueDate and latest Instalment DueDate are on same day - we exclude latest,
    // i.e. 12.06 is earliestInstalmentDueDate and 12.07 is latestInstalmentDueDate - we will exclude 12.07 from range
    var datesInBetweenInclusivity = earliestInstalmentDueDate.get('date') === latestInstalmentDueDate.get('date') ? "[)" : "[]";
    // Earliest payment day can be policy.StartDate + 14 days and latest policy.startDate + 44 days.
    // In cases when payment day is before policy.startDate it should be shifted to next month
    // monthShift is responsible for shifting to specific month.
    if (initialFirstDueDate.isBefore(earliestInstalmentDueDate, "day")) {
        // Set instalment dueDate for monthly renewal
        if (interaction.factors.premiumType == "monthly" && (interaction.process == "renewal" || interaction.process.startsWith("mta"))) {
            return initialFirstDueDate;
        }
        firstDueDate = initialFirstDueDate.add(1, "months");
    }
    else if (initialFirstDueDate.isBetween(earliestInstalmentDueDate, latestInstalmentDueDate, "day", datesInBetweenInclusivity)) {
        firstDueDate = initialFirstDueDate;
    }
    else {
        firstDueDate = initialFirstDueDate.subtract(1, "months");
    }
    return firstDueDate;
}
//# sourceMappingURL=DirectDebitFunctions.js.map